﻿import React, { } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import 'components/form-fields/FormFields.css';


export function FormHeading(
    {
        children = <></>,
        loading = false,
        className = "",
        headingLevel
    }
) {
	if (!children) {
		return null;
	}

	const Heading = headingLevel;
	return (<Heading className={classNames({ "bp6-skeleton": loading }, className)}>{children}</Heading>);
}

FormHeading.propTypes = {
	children: PropTypes.node,
	loading: PropTypes.bool,
	headingLevel: PropTypes.oneOf(['h1', 'h2', 'h3', 'h4', 'h5', 'h6']).isRequired,
	isLoading: PropTypes.bool,
	className: PropTypes.string
};